import React, { RefObject } from "react";
import { IHeaderParams } from "ag-grid-community";
import { Checkbox } from "cfa-react-components";
import I18n from "../../../../i18n/utils";

const operatorHeaderCheckbox = (
  params: IHeaderParams & {
    onSelectOperatorClick: () => void;
    parentNode: any;
    gridRef: RefObject<any>;
    userEmailValidated: boolean;
  }
) => {
  return (
    <>
      <div style={{ display: "flex", padding: 2 }}>
        <div>
          <div>
            <text
              style={{
                top: "50%",
                transform: "translateY(-20%)",
              }}
            >
              {I18n.t("RISK_ANALYSIS_EMAIL")}
            </text>
          </div>
          <div>
            <text
              style={{
                top: "50%",
                transform: "translateY(-20%)",
                paddingRight: 3,
              }}
            >
              {I18n.t("RISK_ANALYSIS_EMAIL_OPERATOR")}
            </text>
          </div>
        </div>
        <Checkbox
          disabled={
            !params.parentNode.data.hasUnEmailedTransactions ||
            !params.userEmailValidated
          }
          checked={params.parentNode.data.emailOperator}
          onClick={params.onSelectOperatorClick}
          onChange={() => {
            params.gridRef.current.api.forEachDetailGridInfo(
              (detailGridInfo: any) => {
                detailGridInfo.api.refreshCells();
              }
            );
            params.gridRef.current.api.refreshCells();
          }}
          //onChange={() =>  params.data.emailOperator = !params.data.emailOperator}
          crossOrigin={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </div>
    </>
  );
};
export default operatorHeaderCheckbox;
